import './PurchaseOrderTrackingNumber.scss';
import Component from './PurchaseOrderTrackingNumber.js';
export default Component;
